import { render, staticRenderFns } from "./appDownload.vue?vue&type=template&id=0a808ece&scoped=true"
import script from "./appDownload.vue?vue&type=script&lang=js"
export * from "./appDownload.vue?vue&type=script&lang=js"
import style0 from "./appDownload.vue?vue&type=style&index=0&id=0a808ece&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a808ece",
  null
  
)

export default component.exports